import { Component, EventEmitter, OnInit, Output, Input, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../validators';
import { Observable, Subject } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { PlatformLocation } from '@angular/common';
import { HttpService } from 'src/services/http.service';
import { debounceTime, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import * as SINONIMO from 'src/assets/sinonimo.json';
import * as accents from 'remove-accents';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { ChangeDetectorRef } from '@angular/core';
import { ErrorReportService } from 'src/services/error-report.service';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss']
})
export class StepOneComponent implements OnInit {

  form: FormGroup;
  @Output() submit: EventEmitter<boolean>;
  @Output() formObserver: Subject<FormGroup>;
  @Input() initData: EventEmitter<any>;
  @ViewChild('auto', { static: false, read: MatAutocompleteTrigger }) autocomplete: MatAutocompleteTrigger;

  mauticFormSrc: any = null;
  mauticFormSrc2: any = null;
  vacancies: Array<any>;
  //allDesirableJobs: Array<any> = [];
  filteredDesirableJobs$: Observable<any>;
  showPassword: boolean = false;
  isSmallScreen$: Observable<boolean>;
  sinonimos: Array<any> = (SINONIMO as any).default;

  allDesirableJobs: any[]; // Defina sua lista de cargos aqui
  filteredDesirableJobs: any[]; // Guarda a lista filtrada
  desiredJobTitle = '';
  separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(
    fb: FormBuilder,
    private sanitazer: DomSanitizer,
    private pLocation: PlatformLocation,
    private http: HttpService,
    private route: ActivatedRoute,
    private breakpoint: BreakpointObserver,
    private snackbar: MatSnackBar,
    private router: Router,
    private errorReport: ErrorReportService,
    @Inject('LinkContrato') public LinkContrato: string,
    @Inject('LinkTermos') public LinkTermos: string,
  ) {

    this.allDesirableJobs = this.sinonimos;
    this.filteredDesirableJobs = [];

    this.form = fb.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      email: [null, [Validators.email, Validators.required]],
      cpf: [null, [Validators.required, CustomValidators.cpf]],
      phone: [null, [Validators.required, CustomValidators.phone]],
      mobile: [null, [Validators.required, CustomValidators.phone]],
      password: [null, Validators.required],
      password2: [null, [Validators.required, CustomValidators.match('password')]],
      desiredJobTitle: [null],
      aboutme: [null, Validators.required],
      desiredJobTitles: [[]],
      acceptTerm: [null, Validators.required],
      acceptContract: [null, Validators.required]
    })
    this.submit = new EventEmitter<any>();
    this.formObserver = new Subject<FormGroup>();
    this.route.queryParams
      .subscribe(
        query => {
          if (query.email)
            this.form.get('email').setValue(query.email);
        }
      )

    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => {
          return state.matches
        })
      )

  }

  ngOnInit() {

    // this.formObserver.next(this.form);
    // this.filteredDesirableJobs$ = this.form.get('desiredJobTitle')
    //   .valueChanges
    //   .pipe(
    //     debounceTime(300),
    //     map(vacancy => this._filterDesirableJobs(vacancy))
    //   );

    // this.http.list('desired_job_aux')
    //   .subscribe(
    //     (result: any) => {
    //       this.allDesirableJobs = result.data;
    //     }
    //   )

    this.form.get('cpf')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cpf => {

          if (!this.form.get('cpf').invalid) {
            const params = {
              cpf: cpf.replace(/[^0-9]/gmi, ''),
              accountType: '',
              dateActive: '2023'
            }

            this.http.get('data_validation:cpf', params)
              .subscribe(
                (result: any) => {
                  const { type, dados } = result;

                  if (type === 'ALREAD_EXIST') {

                    this.form.get('cpf').setErrors({ alread: true });

                    const snackBarRef = this.snackbar.open('Já existe um cadastro registrado com este CPF. Por favor, faça login com o e-mail ' +
                      this.mascararEmail(dados[0]['email']) +
                      '. Se você não se lembra da senha, você pode tentar redefini-la. Se não reconhecer este e-mail, entre em contato com o suporte.', 'Fechar');

                    snackBarRef.afterDismissed().subscribe(info => {
                      this.router.navigate(['/auth/login']);
                    });

                  }
                }
              )
          }
        }
      );

    // this.form.get('phone')
    //   .valueChanges
    //   .pipe(debounceTime(500))
    //   .subscribe(
    //     phone => {

    //       if(!this.form.get('phone').invalid) {
    //         const params = { 
    //           phone: phone.replace(/[^0-9]/gmi, ''),
    //           accountType: 'candidate'
    //         }

    //         this.http.get('data_validation:phone', params)
    //           .subscribe(
    //             (result: any) => {
    //               const { type } = result;
    //               if(type === 'ALREAD_EXIST') {
    //                 this.form.get('phone').setErrors({ alread: true });
    //               }
    //             }                
    //           )
    //       }            
    //     }
    //   );

  }

  ngAfterViewInit() {

    if (this.initData)
      this.initData.subscribe((data) => {

        const [firstname, ...lastname] = data['user'].firstname.split(' ');
        
        // Supondo que data['user'].desired_job_title seja uma string separada por vírgulas
        const jobTitlesString = data['user'].desired_job_title; // Exemplo: "Developer,Designer,Manager"

        // Divide a string em um array de títulos separados por vírgulas
        const jobTitlesArray = jobTitlesString.split(',').map(title => title.trim()); // Remove espaços extras

        // Obtém o array atual do formulário
        const jobs = this.form.get('desiredJobTitles').value as string[];

        // Itera sobre os títulos divididos e os manipula
        jobTitlesArray.forEach(jobTitle => {
          const index = jobs.indexOf(jobTitle);

          if (index >= 0) {
            // Remove o título se já estiver no array
            jobs.splice(index, 1);
          } else {
            // Adiciona o título se não estiver no array
            jobs.push(jobTitle);
          }
        });

        // Atualiza o valor do formulário com o array modificado
        this.form.get('desiredJobTitles').setValue(jobs);


        this.form.patchValue(
          {
            firstname: firstname,
            lastname: lastname.length === 0 ? data['user'].lastname : lastname.join(' '),
            email: data['user'].email,
            cpf: data['user'].cpf,
            phone: data['user'].phone,
            mobile: data['user'].mobile,
            password: data['user'].password,
            password2: data['user'].password,
            acceptTerm: data['user'].accept_term,
            acceptContract: data['user'].acceptcontract,
            aboutme: data['user'].aboutme,
          },
          { emitEvent: false }
        );

      });

  }

  addDesiredJob(event: MatChipInputEvent): void {
    const input = event.input;
    const value = (event.value || '').trim();

    if (!value || this.form.get('desiredJobTitles').value.length === 3) {
      // Se o valor estiver vazio ou se já houver 3 cargos selecionados, não faz nada
      return;
    }

    // Verifica se o valor está na lista de cargos desejados filtrada
    const isValidJob = this.filteredDesirableJobs.some(job => job.Name.toLowerCase() === value.toLowerCase());

    if (!isValidJob) {
      // Se o valor não estiver na lista filtrada, limpa o campo de entrada
      if (input) {
        input.value = '';
      }
      this.form.get('desiredJobTitle').setValue(''); // Limpa o valor do campo usando Angular
      return;
    }

    // Adiciona o valor à lista de cargos desejados
    const jobs = this.form.get('desiredJobTitles').value || [];
    jobs.push(value);
    this.form.get('desiredJobTitles').setValue(jobs);

    // Limpa o campo de entrada
    if (input) {
      input.value = '';
    }

  }


  removeDesiredJob(job: string): void {
    const jobs = this.form.get('desiredJobTitles').value as string[];
    const index = jobs.indexOf(job);

    if (index >= 0) {
      jobs.splice(index, 1);
      this.form.get('desiredJobTitles').setValue(jobs);

      // Habilitar o input se um cargo for removido e o limite máximo não for atingido
      if (jobs.length < 3) {
        this.form.get('desiredJobTitle').enable();
      }
    }
  }


  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    //console.log('Opção selecionada:', event.option.value);
    const value = event.option.value;
    const jobs = this.form.get('desiredJobTitles').value || [];

    if (jobs.length < 3) {

      jobs.push(value);
      this.form.get('desiredJobTitles').setValue(jobs);

      const campo = document.getElementById('desiredJobTitle') as HTMLInputElement;
      if (campo) {
        campo.value = '';
      }

    }
  }

  onSubmit(): void {
    // console.log('CHEGOU');
    if (!this.form.invalid) {
      const data = this.form.getRawValue();
      const params = new URLSearchParams();

      localStorage.setItem('email', data.email);
      localStorage.setItem('password', data.password);
      const fullname = data.firstname+' '+data.lastname;
      localStorage.setItem('name', fullname);

      for (let key in data) {
        const value = data[key];
        if (value)
          params.append(key, value);
      }

      params['desiredJobTitle'] = Array.isArray(data.desiredJobTitles) ? data.desiredJobTitles.join(', ') : data.desiredJobTitles;

      const bHref = this.pLocation.getBaseHrefFromDOM();
      this.mauticFormSrc = this.sanitazer
        .bypassSecurityTrustResourceUrl(`${bHref}mautic-form/step-one?${params.toString()}`);
      // console.log('URL:', this.mauticFormSrc);

      setTimeout(() => {

        const plan = {
          planCode: 'FREE',
          planSignature: '0,00',
          acceptContract: data.acceptContract,
          acceptTerm: data.acceptTerm,
          email: data.email
        }
        
        const params = new URLSearchParams();
  
        for (let key in plan) {
          const value = plan[key];
          if (value)
            params.append(key, value);
        }
  
        const bHref = this.pLocation.getBaseHrefFromDOM();
        this.mauticFormSrc2 = this.sanitazer
          .bypassSecurityTrustResourceUrl(`${bHref}mautic-form/finish?${params.toString()}`);

        // this.http.save('candidate_terms', plan)
        //   .subscribe(
        //     (result: any) => {
        //       console.log('retorno', result);
        //     },
        //     err => this.errorReport.showMessage(err)
        //   )

      }, 2000);

      this.submit.emit();
    }

  }

  onBlurInput(name: string): void {
    const control = this.form.get(name);
    if (control.value && this.filteredDesirableJobs && this.filteredDesirableJobs.findIndex(job => job.Name === control.value) === -1) {
      control.setValue(null);
      control.setErrors({ 'invalid': true });
      const campo = document.getElementById(name) as HTMLInputElement;
      if (campo) {
        campo.value = '';
      }
    }
  }

  onFocusInput(inputName: string) {

    const inputControl = this.form.get(inputName);
    const pristine = inputControl.pristine;

    if (pristine)
      inputControl.setValue(' ');

  }

  checkEmailValidity() {
    const emailControl = this.form.get('email');

    // Verifique se o campo de e-mail é válido antes de continuar
    if (emailControl.valid) {
      const email = emailControl.value;

      const params = {
        email: email,
        accountType: '',
        dateActive: '2023'
      };

      this.http.get('data_validation:email', params)
        .subscribe(
          (result: any) => {
            const { type } = result;
            if (type === 'ALREAD_EXIST') {
              emailControl.setErrors({ alread: true });
              this.snackbar.open('Já existe um cadastro com esse Email, Favor realizar o Login', 'OK');
              setTimeout(() => {
                // window.location.href = 'auth/login';
                this.router.navigate(['/auth/login']);
              }, 3000);
            }
          }
        );
    }
  }

  filterDesirableJobs(value: string): void {
    if (value === null) return;

    if (value.length >= 3) {
      let desirableJob = accents.remove(value).toLowerCase().trim();
      // this.filteredDesirableJobs = this.allDesirableJobs.filter(_desirableJobs => accents.remove(_desirableJobs.Name).toLowerCase().indexOf(desirableJob) > -1);
      this.filteredDesirableJobs = this.allDesirableJobs.filter(job => job.Name.toLowerCase().includes(value.toLowerCase()));
    }

  }

  mascararEmail(email: string): string {
    const [username, domain] = email.split('@');
    const maskedUsername = username.substring(0, 3) + '*'.repeat(username.length - 6) + username.substring(username.length - 3);
    const maskedDomain = domain.substring(0, 3) + '*'.repeat(domain.length - 6) + domain.substring(domain.length - 3);
    return maskedUsername + '@' + maskedDomain;
  }




}
